/**
 * Mobile App Store URLs
 * Single source of truth for mobile app download links
 */
export const APP_STORE_URL =
	'https://apps.apple.com/us/app/stamps-com-mobile-app/id1591959884';
export const GOOGLE_PLAY_URL =
	'https://play.google.com/store/apps/details?id=stamps.mobile.app&hl=en_US';

export default {
	APP_STORE_URL,
	GOOGLE_PLAY_URL,
};
